module.exports = __webpack_public_path__ + "static/media/emotions.c6457319.svg";